import {
  buildAbsoluteUrl,
  CONTACT,
  DEFAULT_OG_IMAGE,
  SITE_LEGAL_NAME,
  SITE_TAGLINE,
  SITE_URL,
  SOCIAL_LINKS,
} from "../constants/seo";
import { resolveAssetUrl } from "./assets";

export function localBusinessSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: SITE_LEGAL_NAME,
    image: buildAbsoluteUrl(DEFAULT_OG_IMAGE),
    url: SITE_URL,
    telephone: CONTACT.phone,
    email: CONTACT.email,
    address: {
      "@type": "PostalAddress",
      streetAddress: CONTACT.address.street,
      addressLocality: CONTACT.address.locality,
      addressCountry: CONTACT.address.country,
    },
    areaServed: {
      "@type": "Country",
      name: "United Arab Emirates",
    },
    description: SITE_TAGLINE,
    foundingDate: "2010",
    sameAs: SOCIAL_LINKS,
  };
}

export function productSchema(product) {
  if (!product) return null;

  const image = product.images?.[0] || product.image;
  const resolved = image ? resolveAssetUrl(image) : null;
  const imageUrl =
    resolved && resolved.startsWith("http")
      ? resolved
      : buildAbsoluteUrl(resolved || DEFAULT_OG_IMAGE);

  const inStock = Number(product.stock) > 0;

  return {
    "@context": "https://schema.org",
    "@type": "Product",
    name: product.name,
    description: (product.description || "").replace(/<[^>]+>/g, "").trim() || product.name,
    image: imageUrl,
    sku: product.sku || undefined,
    brand: {
      "@type": "Brand",
      name: SITE_LEGAL_NAME,
    },
    offers: {
      "@type": "Offer",
      url: buildAbsoluteUrl(`/product/${product.slug || product.id}`),
      priceCurrency: product.currency || "AED",
      price: Number(product.price || 0).toFixed(2),
      availability: inStock
        ? "https://schema.org/InStock"
        : "https://schema.org/OutOfStock",
      seller: {
        "@type": "Organization",
        name: SITE_LEGAL_NAME,
      },
    },
  };
}

export function breadcrumbSchema(items) {
  if (!items?.length) return null;

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: buildAbsoluteUrl(item.path),
    })),
  };
}

export function webSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_LEGAL_NAME,
    url: SITE_URL,
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${SITE_URL.replace(/\/$/, "")}/products?search={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  };
}
